import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Axios instance carrying cookies for admin routes (Authorization header optional fallback)
export const authAxios = axios.create({
  baseURL: API,
  withCredentials: true,
});

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = checking, null = anon
  const [checking, setChecking] = useState(true);

  const check = async () => {
    try {
      const { data } = await authAxios.get("/admin/me");
      setUser(data.user);
    } catch {
      setUser(null);
    } finally {
      setChecking(false);
    }
  };

  useEffect(() => { check(); }, []);

  const login = async (email, password) => {
    const { data } = await authAxios.post("/admin/login", { email, password });
    setUser(data.user);
    // Also keep a bearer in localStorage as a fallback if cookies are blocked
    if (data.access_token) localStorage.setItem("velixa_admin_token", data.access_token);
    return data.user;
  };

  const logout = async () => {
    try { await authAxios.post("/admin/logout"); } catch {}
    localStorage.removeItem("velixa_admin_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, checking, login, logout, refresh: check }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

// Attach bearer token as a fallback for environments where third-party cookies get blocked
authAxios.interceptors.request.use((config) => {
  const t = localStorage.getItem("velixa_admin_token");
  if (t && !config.headers.Authorization) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (typeof detail === "object" && detail.msg) return detail.msg;
  return String(detail);
}
